

import { useNavigate } from 'react-router-dom';
import logo from '../assets/2.png';

const Terms = () => {
    const navigate = useNavigate();

    return (
        <div className="about-layout">
            <img
                src={logo}
                alt="Gibo Logo"
                className="about-logo"
                onClick={() => navigate('/')}
            />

            <div className="about-box">
                <h3>Terms & License</h3>

                <p>
                    Gibo is provided as beta software and is offered on an “as is” basis. Features may
                    change or be removed at any time, and occasional bugs or data loss may occur.
                    By using Gibo, you acknowledge and accept these conditions.
                </p>

                <p>
                    You are granted a personal, non-exclusive, and non-transferable license to use
                    Gibo for lawful purposes. You may not redistribute, modify, or sell the software
                    without explicit permission from the developers.
                </p>

                <p>
                    Gibo collects an email address during sign-up solely for account access,
                    communication, and service-related updates. We do not sell or misuse user data.
                    The application also includes third-party open-source libraries, each governed
                    by its respective license and credited to its original authors.
                </p>
            </div>
        </div>
    );
};

export default Terms;